<template>
  <div>
    <CustomHeader
      :title="title"
      :fectchPastTime="fectchPastTime"
      :fectchRealTime="fectchRealTime"
      :searchInputHeader="searchInputHeader"
      :generatePDF="generatePDF"
    />
    <AverageVisitorSpend
      v-if="isAverageVisitorSpendEnabled"
      :id="'average-visitor-spend'"
      :transportQuestion="localTransportQuestion"
      :consumeQuestion="localConsumeQuestion"
      :visitors="visitors"
      :isLoadingAllData="isLoadingAllData"
    />
    <TransportPerformance
      v-if="isTransportPerformanceEnabled"
      :id="'transport-performance'"
      :isLoadingAllData="isLoadingAllData"
    />
    <HotelOccupancyAndTouristFlow
      v-if="isHotelOccupancyAndTouristFlowEnabled"
      :id="'hotel-occupancy-tourist-flow'"
      :hotelOccupancy="localHotelOccupancy"
      :isLoadingAllData="isLoadingAllData"
    />
    <HotelOccupancy
      v-if="isHotelOccupancyEnabled"
      :id="'hotel-occupancy'"
      :hotelOccupancy="hotelOccupancyByCategory"
      :isLoadingAllData="isLoadingAllData"
    />
    <Reviews
      v-if="isReviewsEnabled"
      :id="'reviews'"
      :reviews="localReviews"
      :isLoadingAllData="isLoadingAllData"
    />
    <Keywords
      v-if="isKeywordsEnabled"
      :id="'keywords'"
      :keyWords="localKeyWords"
      :isLoadingAllData="isLoadingAllData"
    />
    <Event
      v-if="isEventEnabled"
      :id="'event'"
      :events="events"
      :isLoadingAllData="isLoadingAllData"
    />
    <Exchange
      v-if="isExchangeEnabled"
      :id="'exchange'"
      :visitors="visitors"
      :isLoadingAllData="isLoadingAllData"
    />

    <EconomicPerformanceInsights :citiesString="citiesString" :roleIdProp="roleId"/>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import axios from 'axios'
import { useTransportModes } from '../../../stores/transportModes'
import CustomHeader from '../CustomHeader/CustomHeader.vue'
import Layout from '../Layout.vue'
import EconomicPerformanceInsights from './Insights/EconomicPerformanceInsights.vue'
import Exchange from './Components/Exchange/Exchange'
import AverageVisitorSpend from './Components/AverageVisitorSpend/AverageVisitorSpend'
import TransportPerformance from './Components/TransportPerformance/TransportPerformance'
import HotelOccupancyAndTouristFlow from './Components/HotelOccupancyAndTouristFlow/HotelOccupancyAndTouristFlow'
import HotelOccupancy from './Components/HotelOccupancy/HotelOccupancy'
import Reviews from './Components/Reviews/Reviews'
import Keywords from './Components/Keywords/Keywords'
import Event from './Components/Event/Event'

export default {
  name: 'EconomicPerformance',
  components: {
    CustomHeader,
    Exchange,
    AverageVisitorSpend,
    TransportPerformance,
    HotelOccupancyAndTouristFlow,
    HotelOccupancy,
    Reviews,
    Keywords,
    Event,
    EconomicPerformanceInsights,
  },
  layout: Layout,
  props: {
    citiesString: String,
    user: Number,
    roleId: Number,
  },
  data() {
    return {
      title: 'Desempenho Econômico',
      isAverageVisitorSpendEnabled: true,
      isTransportPerformanceEnabled: true,
      isHotelOccupancyAndTouristFlowEnabled: true,
      isHotelOccupancyEnabled: true,
      isReviewsEnabled: true,
      isKeywordsEnabled: true,
      isEventEnabled: true,
      isExchangeEnabled: true,

      printAverageVisitorSpend: true,
      printTransportPerformanceSpend: true,
      printHotelOccupancyAndTouristFlow: true,
      printHotelOccupancy: true,
      printReviews: true,
      printKeywords: true,
      printEvent: true,
      printExchange: true,
      isLoadingAllData: false,
      visitors: {},
      localTransportQuestion: {},
      localConsumeQuestion: {},
      localHotelOccupancy: [],
      localReviews: {},
      localKeyWords: {},
      hotelOccupancyByCategory: [],
      events: [],
    }
  },
  computed: {
    ...mapState(useTransportModes, ['componentsEconomicPerformance']),
    ...mapState(useTransportModes, ['getCurrentComponentsEconomicPerformance']),
    ...mapState(useTransportModes, ['componentsEconomicPerformanceForPrint']),
  },
  watch: {
    getCurrentComponentsEconomicPerformance: {
      deep: true,
      handler(n, o) {
        const currentComponent = n
        this.loadChartSettings(currentComponent.component)
        setTimeout(() => {
          if (currentComponent.component === 'AverageVisitorSpend') {
            this.isAverageVisitorSpendEnabled = currentComponent.enabled
          } else if (currentComponent.component === 'HotelOccupancyAndTouristFlow') {
            this.isHotelOccupancyAndTouristFlowEnabled = currentComponent.enabled
          } else if (currentComponent.component === 'HotelOccupancy') {
            this.isHotelOccupancyEnabled = currentComponent.enabled
          } else if (currentComponent.component === 'Reviews') {
            this.isReviewsEnabled = currentComponent.enabled
          } else if (currentComponent.component === 'Keywords') {
            this.isKeywordsEnabled = currentComponent.enabled
          } else if (currentComponent.component === 'Event') {
            this.isEventEnabled = currentComponent.enabled
          } else if (currentComponent.component === 'Exchange') {
            this.isExchangeEnabled = currentComponent.enabled
          }
        }, 100)
      },
    },
    componentsForPrint: {
      deep: true,
      handler(n, _) {
        n.map((componentToPrint) => {
          Object.keys(componentToPrint).forEach((key) => {
            if (key === 'component' && componentToPrint[key] === 'AverageVisitorSpend') {
              this.printAverageVisitorSpend = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'TransportPerformance') {
              this.printTransportPerformanceSpend = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'HotelOccupancyAndTouristFlow') {
              this.printHotelOccupancyAndTouristFlow = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'HotelOccupancy') {
              this.printHotelOccupancy = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'Reviews') {
              this.printReviews = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'Keywords') {
              this.printKeywords = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'Event') {
              this.printEvent = componentToPrint['print']
            }
            if (key === 'component' && componentToPrint[key] === 'Exchange') {
              this.printExchange = componentToPrint['print']
            }
          })
        })
      },
    },
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    async getAllData() {
      if (this.isLoadingAllData) return

      try {
        this.isLoadingAllData = true
        const response = await axios.post('/api/transport-modes/economic-performance', {
          citiesString: this.citiesString,
          user: this.user,
        })
        this.localTransportQuestion = response.data.transportQuestion
        this.localConsumeQuestion = response.data.consumeQuestion
        this.localReviews = response.data.reviews
        this.localKeyWords = response.data.keyWords
        this.visitors = response.data.visitors
        this.events = response.data.events
        this.localHotelOccupancy = response.data.hotelOccupancy
        this.hotelOccupancyByCategory = response.data.hotelOccupancyByCategory
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingAllData = false
        this.initializeObservers()
      }
    },

    initializeObservers() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targetId = entry.target.id
            switch (targetId) {
              case 'average-visitor-spend':
                if (this.isAverageVisitorSpendEnabled) {
                  this.loadChartSettings('AverageVisitorSpend')
                }
                break
              case 'transport-performance':
                if (this.isTransportPerformanceEnabled) {
                  this.loadChartSettings('TransportPerformance')
                }
                break
              case 'hotel-occupancy-tourist-flow':
                if (this.isHotelOccupancyAndTouristFlowEnabled) {
                  this.loadChartSettings('HotelOccupancyAndTouristFlow')
                }
                break
              case 'hotel-occupancy':
                if (this.isHotelOccupancyEnabled) {
                  this.loadChartSettings('HotelOccupancy')
                }
                break
              case 'reviews':
                if (this.isReviewsEnabled) {
                  this.loadChartSettings('Reviews')
                }
                break
              case 'keywords':
                if (this.isKeywordsEnabled) {
                  this.loadChartSettings('Keywords')
                }
                break
              case 'event':
                if (this.isEventEnabled) {
                  this.loadChartSettings('Event')
                }
                break
              case 'exchange':
                if (this.isExchangeEnabled) {
                  this.loadChartSettings('Exchange')
                }
                break
              default:
                break
            }
            observer.unobserve(entry.target)
          }
        })
      }, observerOptions)

      const targets = [
        'average-visitor-spend',
        'transport-performance',
        'hotel-occupancy-tourist-flow',
        'hotel-occupancy',
        'reviews',
        'keywords',
        'event',
        'exchange',
      ]

      targets.forEach((target) => {
        const element = document.getElementById(target)
        if (element) {
          observer.observe(element)
        }
      })
    },

    async fectchRealTime() {
      try {
        const response = await axios.get('/api/transport-modes/economic-performance')
        this.localTransportQuestion = response.data.transportQuestion
        this.localConsumeQuestion = response.data.consumeQuestion
        this.localHotelOccupancy = response.data.hotelOccupancy
        this.localReviews = response.data.reviews
        this.localKeyWords = response.data.keyWords
        this.$toast.add({
          severity: 'success',
          summary: 'Dados atualizados com sucesso!',
          life: 3000,
        })
      } catch (error) {
        console.error(error)
      }
    },
    async fectchPastTime(days) {
      try {
        const response = await axios.post('/api/transport-modes/economic-performance/past-data', {
          days,
        })
        this.localTransportQuestion = response.data.transportQuestion
        this.localConsumeQuestion = response.data.consumeQuestion
        this.localHotelOccupancy = response.data.hotelOccupancy
        this.$toast.add({
          severity: 'success',
          summary: 'Dados atualizados com sucesso!',
          life: 3000,
        })
      } catch (error) {
        console.error(error)
      }
    },

    generatePDF() {
      this.$refs.html2Pdf.generatePdf()
    },
    searchInputHeader(event) {},

    loadChartSettings(component) {
      const transportModes = useTransportModes()
      const customHeaderComponents = transportModes.componentsEconomicPerformance.map(
        (component) => {
          return {
            id: component.id,
            field: component.field,
            component: component.component,
            enabled: component.enabled,
          }
        },
      )

      if (component) {
        this[`is${component}Enabled`] = customHeaderComponents.some(
          (comp) => comp.component === component && comp.enabled,
        )
      } else {
        this.isAverageVisitorSpendEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'AverageVisitorSpend' && comp.enabled,
        )
        this.isTransportPerformanceEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'TransportPerformance' && comp.enabled,
        )
        this.isHotelOccupancyAndTouristFlowEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'HotelOccupancyAndTouristFlow' && comp.enabled,
        )
        this.isHotelOccupancyEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'HotelOccupancy' && comp.enabled,
        )
        this.isReviewsEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'Reviews' && comp.enabled,
        )
        this.isKeywordsEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'Keywords' && comp.enabled,
        )
        this.isEventEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'Event' && comp.enabled,
        )
        this.isExchangeEnabled = customHeaderComponents.some(
          (comp) => comp.component === 'Exchange' && comp.enabled,
        )
      }
    },
  },
}
</script>

<style src="./styles.css"></style>
